module.exports = __webpack_public_path__ + "static/media/6.d525fb83.jpg";